import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';

const AddressChangeDeclined = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'addressChangeDeclined',
  });

  const goBack = () => {
    router.dismissTo({ pathname: '/myvaro/personal-details' });
  };

  useBackHandler(goBack);

  return (
    <View style={styles.container}>
      <ScreenTransitionOverlay
        isLoading={false}
        LoadingComponent={undefined}
        ErrorComponent={
          <ErrorScreen
            screenType={ErrorScreenType.Error}
            messageHeadline={translatedText('header')}
            messageBody={translatedText('description')}
            primaryButton={{
              title: translatedText('primaryButton'),
              onPress: () => {
                router.push({ pathname: '/myvaro/help' });
              },
            }}
            secondaryButton={{
              title: translatedText('secondaryButton'),
              onPress: goBack,
            }}
          />
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default AddressChangeDeclined;
